<template>
  <v-modal min-width="40rem" v-model="showModel" handle-click-bg :animation="screen.breakPoint.tabPort ? 'slide-down' : 'slide-up'" fit-content :full="!screen.breakPoint.tabPort" :position="screen.breakPoint.tabPort ? 'top' : 'bottom'">
    <template v-slot:activator="{on}" v-if="!noBtn">
      <v-button @click="on" class="ml-auto" color="success" :size="screen.breakPoint.tabPort ? null : null"><span class="d-inline-block icon-plus"></span> {{ $t('views.Dashboard.Orders.addOrder') }}</v-button>
    </template>

    <template v-slot:header>
      {{ $t('views.Dashboard.Orders.addOrder') }}
    </template>

    <autocomplete not-empty value-field="id" item-text="fullName" v-model="currContractId" :items="contracts" :placeholder="$t('views.Orders.contractSelect.label')" class="mb-2" :disabled="loading"></autocomplete>
    <div class="d-flex">
      <v-input :error="errors.userUid ? $t(errors.userUid) : null" :label="$t('views.Components.AddOrder.userUidShort')" :placeholder="$t('views.Components.AddOrder.userUid')" v-model="computedUserUid" class="mb-2" :disabled="loading || (userUid && true)"></v-input>
      <qr-code-scan v-if="!userUid" class="px-1" @change="handleQrCode"></qr-code-scan>
      <v-button inline v-else @click="userUid = null" class="px-1"><span class="icon-close text-color-space-light" style="font-size: 3rem;"></span></v-button>
    </div>
    <v-input min="0" :error="errors.amount ? $t(errors.amount) : null" :placeholder="$t('views.Components.AddOrder.orderAmount')" v-model="formData.amount" class="mb-2" type-name="number" :disabled="loading"></v-input>
    <date-input :error="errors.dateOrder ? $t(errors.dateOrder) : null" :placeholder="$t('views.Components.AddOrder.orderDate')" v-model="formData.dateOrder" mode="dateTime" is24hr></date-input>

    <template v-slot:footer><v-button color="success" width="full" @click="validate" :loading="loading">{{ $t('views.Dashboard.Orders.addOrder') }}</v-button></template>
  </v-modal>
</template>

<script>
import vButton from '@/ui/controls/vButton'
import vModal from '@/ui/modals/vModal'
import Autocomplete from '@/ui/controls/Autocomplete'
import vInput from '@/ui/controls/vInput'
import DateInput from '@/ui/controls/DateInput'

import QrCodeScan from '@/components/QrCodeScan'

import screen from '@/mixins/screen'
import currContractId from '@/mixins/currContractId'
import contracts from '@/mixins/contracts'

import { now } from '@/utils'

export default {
  mixins: [screen, currContractId, contracts],

  props: {
    noBtn: {
      type: Boolean,
      default: false
    },

    loading: {
      type: Boolean,
      default: false
    },

    value: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      userUid: null,
      formData: {
        userUid: null,
        amount: null,
        dateOrder: now.toISOString()
      },
      errors: {
        userUid: null,
        amount: null,
        dateOrder: null
      }
    }
  },

  computed: {
    showModel: {
      get () {
        return this.value
      },

      set (val) {
        this.$emit('input', JSON.parse(val))
      }
    },

    computedUserUid: {
      get () {
        if (this.userUid) {
          return this.userUid
        }

        return this.formData.userUid
      },

      set (val) {
        this.formData.userUid = val
      }
    }
  },

  methods: {
    handleQrCode (e) {
      if (e) {
        this.userUid = e
      }
    },

    validate () {
      const formData = this.formData

      for (const key of Object.keys(formData)) {
        if ((!formData[key] && !this[key])) {
          this.errors[key] = 'errors.Components.AddOrder.validation.mustNotBeEmpty'
        }
      }

      if (formData.amount <= 0) {
        this.errors.amount = 'errors.Components.AddOrder.validation.mustBeGreaterThanZero'
      }

      if (Object.keys(this.errors).some(key => this.errors[key] && true)) {
        return
      }

      this.$emit('add', {
        userUid: this.computedUserUid.trim(),
        amount: +this.formData.amount,
        dateOrder: this.formData.dateOrder,
        partnerContractId: +this.currContractId
      })
    }
  },

  watch: {
    formData: {
      handler: function () {
        this.errors = {
          userUid: null,
          amount: null,
          dateOrder: null
        }
      },
      deep: true
    },

    showModel (val) {
      if (!val) {
        this.formData = {
          userUid: null,
          amount: null,
          dateOrder: now.toISOString()
        }
      }
    }
  },

  components: {
    vButton,
    vModal,
    Autocomplete,
    vInput,
    DateInput,
    QrCodeScan
  }
}
</script>
